import {
  actionButtonStyles,
  actionsMenuPaperCommonStyles,
  actionsMenuSpanCommonStyles,
  applyButtonStyles,
  basePrimaryButtonStyles,
  baseSecondaryButtonStyles,
  checkboxContainerStyles,
  closeIconCompactStyles,
  emptyStateTextCenteredStyles,
  emptyStateTextCompactStyles,
  filterPopoverContentStyles,
  modalConfirmationButtonCommonStyles,
  rowSelectContainerCommonStyles,
  scrollShadowAfterStyles,
  scrollShadowBeforeStyles,
  selectedTooltipCommonStyles,
  statusClampAfterStyles,
  statusClampCommonStyles,
  statusClampDropdownAfterStyles,
  statusClampDropdownStyles,
  statusClampHoverStyles,
  subPageHeaderStyles,
  switchLabelsCommonStyles
} from './commonStyles';
import {
  BLACK,
  BODY_TEXT,
  DARK_GREY,
  DIVIDER,
  GREY,
  SCOUT_BLUE,
  SCOUT_TEAL,
  WHITE
} from '../../ThemeContext/constants';
import { theme } from '../../ThemeContext/ThemeObject';

import type { CSSProperties } from 'react';

import type { IStyle } from '../Job/types';

export const notesEditSaveButton: IStyle | CSSProperties = {
  ...basePrimaryButtonStyles,
  width: '86px',
  padding: '5px 0px',
  '& svg': {
    color: WHITE,
    fontSize: '16px !important'
  },
  '&:disabled': {
    backgroundColor: '#EEEEEE',
    color: '#BBBBBB',
    transition: 'all 250ms ease-in-out'
  }
};

export const notesCancelButton: IStyle | CSSProperties = {
  ...baseSecondaryButtonStyles,
  width: '86px',
  padding: '5px 0px',
  '& svg': {
    color: theme.palette.error.main,
    fontSize: '16px !important'
  }
};

export const editNotePopover: IStyle = {
  '& .MuiPaper-root': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    rowGap: '10px',
    width: '300px',
    minHeight: '150px',
    padding: '17px 17px 14px 17px'
  }
};

export const statusClamp: IStyle | CSSProperties = {
  ...statusClampCommonStyles,
  width: '140px',
  padding: '6px 20px 5px 24px',
  '&::after': statusClampAfterStyles,
  '& .status-dropdown-full': {
    ...statusClampDropdownStyles,
    width: '140px',
    padding: '6px 20px 5px 24px',
    '&::after': statusClampDropdownAfterStyles
  },
  '&:hover': statusClampHoverStyles
};

export const scrollShadowLeft: IStyle = {
  '&::after': {
    ...scrollShadowAfterStyles,
    right: '-2px'
  },
  '&::before': {
    ...scrollShadowBeforeStyles,
    right: '0'
  }
};

export const scrollShadowRight: IStyle = {
  '&::after': {
    ...scrollShadowAfterStyles,
    left: '-2px'
  },
  '&::before': {
    ...scrollShadowBeforeStyles,
    left: '0'
  }
};

export const searchInput = {
  fontFamily: 'Source Sans Pro',
  fontSize: '20px',
  fontWeight: 'regular',
  borderRadius: '6px',
  minHeight: '54px',
  '& legend': {
    display: 'none'
  },
  '& svg': {
    fontSize: '31px',
    color: SCOUT_BLUE
  },
  '& input': {
    padding: '10.5px 11px 15.5px 11px',
    color: BLACK
  },
  '& fieldset': {
    borderColor: '#EAEEF0'
  },
  '&:hover': {
    '& fieldset': {
      borderColor: '#DADEE0 !important'
    }
  }
};

export const chip: IStyle | CSSProperties = {
  fontFamily: 'Source Sans Pro',
  fontSize: '18px',
  fontWeight: '600',
  padding: '20px 12px',
  borderRadius: '25px',
  backgroundColor: WHITE,
  border: '2px solid #CCCCCC',
  color: '#CCCCCC',
  transition: 'all 0.4s ease-in-out',
  '&:hover': {
    backgroundColor: WHITE
  }
};

export const chipPacket: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: '20px',
  columnGap: '26px',
  marginTop: '36px'
};

export const chipSelected: IStyle | CSSProperties = {
  fontFamily: 'Source Sans Pro',
  fontSize: '18px',
  fontWeight: '600',
  padding: '20px 12px',
  borderRadius: '25px',
  color: theme.palette.primary.main,
  backgroundColor: WHITE,
  border: `2px solid ${theme.palette.action.main}`,
  transition: 'all 0.4s ease-in-out',
  '&:hover': {
    backgroundColor: WHITE
  }
};

export const actionsMenu: IStyle | CSSProperties = {
  '& .MuiPaper-root': {
    ...actionsMenuPaperCommonStyles,
    width: '170px',
    marginTop: '12px'
  },
  '& span': actionsMenuSpanCommonStyles
};

export const filterMenu: IStyle | CSSProperties = {
  '& .MuiPaper-root': {
    ...actionsMenuPaperCommonStyles,
    rowGap: '11px',
    minWidth: '166px',
    marginTop: '6px'
  },
  '& span': {
    ...actionsMenuSpanCommonStyles,
    color: GREY
  }
};

export const fileName: CSSProperties = {
  fontFamily: 'Source Sans Pro',
  fontSize: '14px',
  fontWeight: 'bold',
  color: theme.palette.primary.main,
  maxWidth: '240px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};

export const connectingLine: IStyle = {
  '&:before': {
    content: '""',
    display: 'block',
    width: '1px',
    background: '#edf2f5',
    height: '100%',
    position: 'absolute',
    left: '15px',
    top: '30px'
  }
};

export const sortableSwitchLabels = {
  ...switchLabelsCommonStyles,
  marginLeft: '4px'
};

export const filterSwitchLabels: IStyle | CSSProperties = {
  ...switchLabelsCommonStyles,
  marginLeft: '0px'
};

export const rowSelect = {
  fontFamily: 'Source Sans Pro',
  fontSize: '14px',
  color: DARK_GREY,
  fontWeight: 'bold',
  borderRadius: '6px !important',
  '& legend': {
    display: 'none'
  },
  '& svg': {
    display: 'none'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#DBDEDF'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#CACDCE'
  },
  '& .MuiOutlinedInput-input': {
    padding: '4px 12px 8px 12px !important'
  }
};

export const pagination = {
  marginRight: '24px',
  '& button': {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#CCCCCC',
    margin: '0px -2px'
  },
  '& .Mui-selected': {
    color: DARK_GREY,
    backgroundColor: `${WHITE} !important`,
    '&:hover': {
      backgroundColor: `${WHITE} !important`
    }
  },
  '& .MuiPaginationItem-previousNext': {
    color: DARK_GREY
  }
};

export const csvExportModal: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  padding: '60px',
  width: '520px',
  borderRadius: '6px',
  dropShadow: '0px 2px 14px #305A6F29',
  position: 'absolute',
  background: WHITE,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontFamily: 'Source Sans Pro',
  color: BODY_TEXT
};

export const csvExportHeader: CSSProperties = {
  fontSize: '20px',
  fontWeight: '600'
};

export const csvExportSubheader: CSSProperties = {
  color: BODY_TEXT,
  fontSize: '14px'
};

export const closeIcon = {
  position: 'absolute',
  top: '20px',
  right: '20px',
  cursor: 'pointer',
  color: DIVIDER
} satisfies CSSProperties;

export const closeIconCompact: CSSProperties = closeIconCompactStyles;

export const noQuestionsText = emptyStateTextCenteredStyles;

export const emptyStateText: CSSProperties = emptyStateTextCompactStyles;

export const subPageHeader: CSSProperties = subPageHeaderStyles;

export const switchLabels = {
  ...switchLabelsCommonStyles,
  width: '200px'
};

export const clearButton: IStyle | CSSProperties = {
  ...baseSecondaryButtonStyles,
  fontSize: '10px',
  padding: '5px 10px',
  '& .MuiButton-endIcon svg': {
    fontSize: '10px'
  }
};

export const modalSendButton = {
  ...basePrimaryButtonStyles,
  padding: '8px 19px',
  '&:focus': {
    outline: 'none'
  }
} satisfies IStyle | CSSProperties;

export const deleteApplicant: IStyle | CSSProperties = {
  color: theme.palette.error.main,
  backgroundColor: '#D6827D33',
  '&:hover': {
    color: WHITE,
    backgroundColor: theme.palette.error.main,
    border: 'none'
  }
};

export const link: IStyle | CSSProperties = {
  fontSize: '19px',
  cursor: 'pointer',
  color: GREY,
  transition: 'color 0.2s ease-in-out',
  '&:hover': {
    color: '#737373'
  },
  '@media (max-width: 1450px)': {
    fontSize: '16px'
  },
  '@media (max-width: 1260px)': {
    fontSize: '14px'
  }
};

export const copyButton: IStyle | CSSProperties = {
  fontSize: '12px',
  fontWeight: 'bold',
  backgroundColor: `${SCOUT_TEAL}1F`,
  color: theme.palette.action.main,
  borderRadius: '6px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.action.main,
    color: WHITE
  }
};

export const actionModalFormLine = {
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  columnGap: '50px',
  rowGap: '26px',
  alignItems: 'center',
  marginBottom: '26px',
  width: '100%',
  marginLeft: '12px'
} satisfies CSSProperties;

export const csvExportButton: IStyle | CSSProperties = {
  fontFamily: 'Source Sans Pro',
  fontSize: '16px',
  fontWeight: 'bold',
  textTransform: 'none',
  color: WHITE,
  backgroundColor: theme.palette.action.main,
  borderRadius: '8px',
  height: '58px',
  marginTop: '42px',
  '&:hover': {
    backgroundColor: '#4da8a4'
  }
};

export const rightArrow: IStyle | CSSProperties = {
  display: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'sticky',
  width: '40px',
  height: '65px',
  bottom: '370px',
  borderRadius: '10px 0px 0px 10px',
  background: '#eeeeee',
  zIndex: '9999',
  opacity: '0.9',
  cursor: 'pointer'
};

export const applyButton: IStyle | CSSProperties = {
  ...applyButtonStyles,
  fontSize: '10px'
};

export const actionButton: IStyle | CSSProperties = {
  ...actionButtonStyles
};

export const filterPopoverContent: IStyle | CSSProperties = {
  ...filterPopoverContentStyles,
  overflowY: 'scroll'
};

export const paginationContainer = {
  display: 'flex',
  alignItems: 'center',
  width: 'fit-content',
  marginTop: '5px',
  padding: '12px',
  fontFamily: 'Source Sans Pro',
  fontSize: '14px',
  fontWeight: 'bold',
  color: DARK_GREY
};

export const selectedApplicantsTableHeader: CSSProperties = {
  fontFamily: 'Source Sans Pro',
  fontSize: '16px',
  fontWeight: '600',
  color: theme.palette.primary.main,
  marginTop: '24px',
  marginBottom: '20px'
};

export const checkboxLabel: IStyle | CSSProperties = {
  '& .MuiTypography-root': {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    color: GREY
  },
  '& span': {
    color: theme.palette.error.main
  }
};

export const modalCreateButton: IStyle | CSSProperties = {
  ...modalConfirmationButtonCommonStyles,
  padding: '8px 19px'
};

export const selectedTooltip: CSSProperties = {
  ...selectedTooltipCommonStyles,
  justifyContent: 'space-evenly',
  padding: '20px 30px',
  minWidth: '665px',
  left: 'calc(50% - 350px)'
};

export const rowSelectContainer = {
  ...rowSelectContainerCommonStyles,
  padding: '12px'
};

export const rowSelectContainerAlt: IStyle | CSSProperties = {
  ...rowSelectContainerCommonStyles,
  padding: '8px'
};

export const checkboxContainer: IStyle | CSSProperties = {
  ...checkboxContainerStyles,
  marginTop: '24px'
};
